import { ReactNode } from 'react';
import styled from 'styled-components';
import { media } from '@morressier/ts';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import '@reach/dialog/styles.css';

const StyledDialog = styled(DialogOverlay)`
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 2003;
`;

const StyledContent = styled(DialogContent)`
  padding: 0;
  max-width: 1216px;
  ${media.xxsmall`
    width: 100%;
    height: 100%;
    margin: 0;
  `}
  ${media.small`
    height: 90vh;
    width: 90vw;
    margin: 5vh auto;
    border-radius: 8px;
    overflow: hidden;
  `}
`;

interface IModalProps {
  children?: ReactNode;
  isOpen: boolean;
  onDismiss?: () => void;
  ariaLabel?: string;
  scrollable?: boolean;
}

const Modal = (props: IModalProps) => {
  const { isOpen, onDismiss, children, ariaLabel = '', scrollable } = props;
  return (
    <StyledDialog isOpen={isOpen} onDismiss={onDismiss}>
      <StyledContent
        style={{ overflow: scrollable ? 'auto' : 'hidden' }}
        aria-label={ariaLabel}
      >
        {children}
      </StyledContent>
    </StyledDialog>
  );
};
export default Modal;
